import React from 'react';

const ContactUs = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Left Section */}
        <div style={styles.leftSection}>
          <h4 style={styles.subHeading}> CONTACT DETAILS</h4>
          <h1 style={styles.title}>Contact us</h1>
          <p style={styles.description}>
            Give us a call or fill in the contact form, we endeavour to answer all enquiries within 24 hours on business days. We will be happy to answer your questions.
          </p>

          <div style={styles.infoBlock}>
            <span style={styles.icon}></span>
            <div>
              <strong>Our Address:</strong>
              <p>Ryiadh<br />Egypt<br />Egypt</p>
            </div>
          </div>

          <div style={styles.infoBlock}>
            <span style={styles.icon}></span>
            <div>
              <strong>Our Mailbox:</strong>
              <p>sales@sobek.com</p>
            </div>
          </div>

          <div style={styles.infoBlock}>
            <span style={styles.icon}></span>
            <div>
              <strong>Our Phone:</strong>
              <p>+31 50 211 0662</p>
            </div>
          </div>
        </div>

        {/* Right Section (Form) */}
        <div style={styles.rightSection}>
          <form style={styles.form}>
            <label>Company*</label>
            <input
              type="text"
              placeholder="Fill in your company name"
              style={{ fontSize: '15px', padding: '3px' }}
            />

            <label>Full name*</label>
            <input
              type="text"
              placeholder="Fill in your full name"
              style={{ fontSize: '15px', padding: '3px' }}
            />

            <label>E-mail*</label>
            <input
              type="email"
              placeholder="Fill in your e-mailaddress"
              style={{ fontSize: '15px', padding: '3px' }}
            />

            <label>Phone*</label>
            <input
              type="text"
              placeholder="Include your country code"
              style={{ fontSize: '15px', padding: '3px' }}
            />

            <label>Contact message*</label>
            <textarea
              placeholder="How can we help you?"
              rows={5}
              style={{ fontSize: '15px', padding: '3px' }}
            ></textarea>

            <label>Please verify your request*</label>
            <div style={styles.recaptcha}>[reCAPTCHA placeholder]</div>

            <button type="submit" style={styles.submitButton}>Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: '#111',
    color: '#fff',
    fontFamily: 'Arial, sans-serif',
    padding: '60px 20px',
  },
  container: {
    display: 'flex',
    maxWidth: '1200px',
    margin: '0 auto',
    gap: '60px',
  },
  leftSection: {
    flex: 1,
    
  },
  rightSection: {
    flex: 1,
    backgroundColor: '#1a1a1a',
    padding: '20px',
    borderRadius: '10px',
    color: '#C18429',
    textAlign: 'left' // ✅ تأكيد المحاذاة لليسار
  },
  subHeading: {
    color: '#deb878',
    fontSize: '14px',
    marginBottom: '5px',
    textAlign: 'left'
  },
  title: {
    fontSize: '36px',
    marginBottom: '15px',
    color: '#fff',
    textAlign: 'left'
  },
  description: {
    fontSize: '16px',
    color: '#ccc',
    lineHeight: '1.6',
    marginBottom: '40px',
    textAlign: 'left'
  },
  infoBlock: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    marginBottom: '30px',
    textAlign: 'left'
  },
  icon: {
    fontSize: '20px',
    color: '#1ba99e'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  recaptcha: {
    backgroundColor: '#eee',
    padding: '20px',
    border: '1px solid #ccc',
    textAlign: 'center'
  },
  submitButton: {
    backgroundColor: '#1ba99e',
    color: '#fff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
    alignSelf: 'flex-start'
  }
};

export default ContactUs;
